import { Observable } from 'rxjs';

export abstract class AssetLoader {
  constructor() {

  }

  public abstract load(url: string): Observable<any>;
}
